import React, { useState } from 'react';
import axios from 'axios';

const CreateTicketForm = ({ onTicketCreated }) => {
  const apiUrl = process.env.REACT_APP_API_URL;
  const [formData, setFormData] = useState({
    title: '',
    description: '',
    priority: 'medium',
    category: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      await axios.post(
        `${apiUrl}/support/create`,
        formData,
        {
          headers: {
            loginToken: localStorage.getItem('loginToken'),
          },
        }
      );

      // Reset form
      setFormData({
        title: '',
        description: '',
        priority: 'medium',
        category: ''
      });

      onTicketCreated();
    } catch (error) {
      console.error('Error creating ticket:', error);
      setError(error.response?.data?.error || 'Failed to create ticket');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className='bg-white rounded-lg shadow p-6'>
      <h2 className='text-xl font-semibold mb-4'>Create Support Ticket</h2>

      {error && (
        <div className='mb-4 p-3 bg-red-100 border border-red-400 text-red-700 rounded'>
          {error}
        </div>
      )}

      <form onSubmit={handleSubmit} className='space-y-4'>
        <div>
          <label htmlFor='title' className='block text-sm font-medium text-gray-700 mb-1'>
            Title *
          </label>
          <input
            type='text'
            id='title'
            name='title'
            value={formData.title}
            onChange={handleChange}
            required
            minLength={5}
            maxLength={100}
            className='w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-yellow-500'
            placeholder='Brief description of the issue'
          />
        </div>

        <div>
          <label htmlFor='category' className='block text-sm font-medium text-gray-700 mb-1'>
            Category
          </label>
          <select
            id='category'
            name='category'
            value={formData.category}
            onChange={handleChange}
            className='w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-yellow-500'
          >
            <option value=''>Select category</option>
            <option value='technical'>Technical Issue</option>
            <option value='account'>Account Problem</option>
            <option value='billing'>Billing</option>
            <option value='feature'>Feature Request</option>
            <option value='other'>Other</option>
          </select>
        </div>

        <div>
          <label htmlFor='priority' className='block text-sm font-medium text-gray-700 mb-1'>
            Priority
          </label>
          <select
            id='priority'
            name='priority'
            value={formData.priority}
            onChange={handleChange}
            className='w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-yellow-500'
          >
            <option value='low'>Low</option>
            <option value='medium'>Medium</option>
            <option value='high'>High</option>
            <option value='urgent'>Urgent</option>
          </select>
        </div>

        <div>
          <label htmlFor='description' className='block text-sm font-medium text-gray-700 mb-1'>
            Description *
          </label>
          <textarea
            id='description'
            name='description'
            value={formData.description}
            onChange={handleChange}
            required
            minLength={10}
            maxLength={1000}
            rows={6}
            className='w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-yellow-500'
            placeholder='Detailed description of your issue or request'
          />
        </div>

        <div className='flex justify-end'>
          <button
            type='submit'
            disabled={loading}
            className={`px-6 py-2 rounded-md font-medium ${
              loading
                ? 'bg-gray-400 cursor-not-allowed'
                : 'bg-yellow-500 hover:bg-yellow-600 text-white'
            }`}
          >
            {loading ? 'Creating...' : 'Create Ticket'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default CreateTicketForm;